import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import {filter} from 'rxjs/operators';

@Injectable()
export class NavigationService {

    private _isGoingBack = false;

    constructor(router: Router) {
       router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(_e => {
           this._isGoingBack = false;
       });
    }

    isGoingBack() {
        console.log('isGoingBack', this._isGoingBack);
        const isGoingBack = this._isGoingBack;
        this._isGoingBack = false; // reset
        return isGoingBack;
    }

    markAsGoingBack() {
        this._isGoingBack = true;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/services/navigation.service.ts